(function() {
    var a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p = function(a, b) {
        return function() {
            return a.apply(b, arguments)
        }
    };
    a = function() {
        function a(a) {
            this.container = a, this.loading_animation = $(".fw__loading_animation"), this.loading_animation.spin(this.loading_animation.hasClass("tiny") ? "tiny" : "small")
        }
        return a
    }(), b = function() {
        function a() {
            this.screenSizeListener = p(this.screenSizeListener, this), this.getScreenSize = p(this.getScreenSize, this), this.medium_screen = 768, this.large_screen = 1024, this.current_window = null, this.getScreenSize(), this.screenSizeListener()
        }
        return a.prototype.getScreenSize = function() {
            var a;
            if (a = this, $("html").hasClass("lt-ie9")) return $.event.trigger("largeWindow"), a.current_window = "large";
            if (window.matchMedia("only screen and (min-width: " + a.large_screen + "px)").matches) {
                if ("large" !== a.current_window) return $.event.trigger("largeWindow"), a.current_window = "large"
            } else if (window.matchMedia("only screen and (min-width: " + a.medium_screen + "px)").matches) {
                if ("medium" !== a.current_window) return $.event.trigger("mediumWindow"), a.current_window = "medium"
            } else if ("small" !== a.current_window) return $.event.trigger("smallWindow"), a.current_window = "small"
        }, a.prototype.screenSizeListener = function() {
            var a;
            return a = this, $(window).resize(function() {
                return a.getScreenSize()
            })
        }, a
    }(), c = function() {
        function a(a, b, c, d) {
            return this.container = a, this.column_a = b, this.column_b = c, this.mq = d, this.Listeners = p(this.Listeners, this), this.setColumnPosition = p(this.setColumnPosition, this), this.getAlignment = p(this.getAlignment, this), this.getState = p(this.getState, this), this.resetLargerColumn = p(this.resetLargerColumn, this), this.getSmallerColumn = p(this.getSmallerColumn, this), this.heightsHaveChanged = p(this.heightsHaveChanged, this), this.setHeights = p(this.setHeights, this), this.loadColumns = p(this.loadColumns, this), Modernizr.touch ? !1 : (this.container.offset().top, this.current_state = "auto", this.column_a_height = 0, this.column_b_height = 0, void this.loadColumns())
        }
        return a.prototype.loadColumns = function() {
            var a;
            return a = this, a.container.imagesLoaded(function() {
                return a.Listeners(), a.setColumnPosition()
            })
        }, a.prototype.setHeights = function() {
            return this.column_a_height = this.column_a.outerHeight(), this.column_b_height = this.column_b.outerHeight()
        }, a.prototype.heightsHaveChanged = function() {
            return this.column_a.outerHeight() !== this.column_a_height ? (this.setHeights(), !0) : this.column_b.outerHeight() !== this.column_b_height ? (this.setHeights(), !0) : !1
        }, a.prototype.getSmallerColumn = function() {
            return this.column_a_height < this.column_b_height ? this.column_a : this.column_b
        }, a.prototype.resetLargerColumn = function() {
            return this.column_a_height > this.column_b_height ? this.column_a.css({
                position: "relative",
                top: "auto",
                bottom: "auto"
            }) : this.column_b.css({
                position: "relative",
                top: "auto",
                bottom: "auto"
            })
        }, a.prototype.getState = function(a, b, c) {
            var d, e, f, g;
            return g = "auto", "small" === this.mq.current_window ? "auto" : (d = c.outerHeight(), b > d && (f = !0), a < this.container.offset().top && (g = "auto"), e = f ? d : b, a + e > this.container.offset().top + this.container.outerHeight() ? g = "absolute-bottom" : a > this.container.offset().top && f ? g = "fixed-top" : d > b && a + b > this.container.offset().top + c.outerHeight() && (g = "fixed-bottom"), g)
        }, a.prototype.getAlignment = function(a) {
            return a.hasClass("column-a") ? "left" : a.hasClass("column-b") ? "right" : void 0
        }, a.prototype.setColumnPosition = function() {
            var a, b, c, d;
            return d = this, d.setHeights(), b = d.getSmallerColumn(), c = d.getState($(window).scrollTop(), $(window).height(), b), a = d.getAlignment(b), "auto" === c && "auto" !== this.current_state ? (this.current_state = "auto", b.css({
                position: "relative",
                top: "auto",
                bottom: "auto"
            })) : "fixed-bottom" === c && "fixed-bottom" !== this.current_state ? (this.current_state = "fixed-bottom", b.css({
                position: "fixed",
                top: "auto",
                bottom: 0
            })) : "fixed-top" === c && "fixed-top" !== this.current_state ? (this.current_state = "fixed-top", b.css({
                position: "fixed",
                top: 0,
                bottom: "auto"
            })) : "absolute-bottom" === c && "absolute-bottom" !== this.current_state && (this.current_state = "absolute-bottom", b.css({
                position: "absolute",
                top: "auto",
                bottom: 0
            })), "right" === a ? b.css({
                right: 0
            }) : void 0
        }, a.prototype.Listeners = function() {
            var a;
            return a = this, $(window).scroll(function() {
                return a.setColumnPosition()
            }), setInterval(function() {
                return a.heightsHaveChanged() ? (a.resetLargerColumn(), a.setColumnPosition()) : void 0
            }, 250), $(window).resize(function() {
                return a.resetLargerColumn(), a.setColumnPosition()
            })
        }, a
    }(), d = function() {
        function a(a) {
            this.container = a, this.calculateWidths = p(this.calculateWidths, this), this.footer_blocks = this.container.find(" > .block"), this.calculateWidths()
        }
        return a.prototype.calculateWidths = function() {
            var a;
            return a = 0, this.footer_blocks.each(function() {
                return a += $(this).data("width")
            }), this.footer_blocks.each(function() {
                var b;
                return b = $(this).data("width") / a * 100 + "%", $(this).outerWidth(b)
            })
        }, a
    }(), e = function() {
        function a(a) {
            this.container = a, this.resizeListeners = p(this.resizeListeners, this), this.positionElements = p(this.positionElements, this), this.verticalAlign = p(this.verticalAlign, this), this.minHeight = p(this.minHeight, this), this.social_media = this.container.find(".partial--social-media"), this.account = this.container.find(".layout__login"), this.currency = this.container.find(".partial--currency-selector"), this.menu_link = this.container.find(".mobile_menu_link"), this.cart_link = this.container.find(".cart-link"), this.top_row = this.container.find(".top-row"), this.left_column = this.container.find(".top-row .left-column"), this.right_column = this.container.find(".top-row .right-column"), this.positionElements(), this.minHeight(), this.resizeListeners()
        }
        return a.prototype.minHeight = function() {
            var a, b;
            return a = this.left_column.outerHeight() + 30, b = this.right_column.outerHeight() + 30, a > this.top_row.outerHeight() && this.top_row.css("min-height", a), b > this.top_row.outerHeight() ? this.top_row.css("min-height", b) : void 0
        }, a.prototype.verticalAlign = function(a) {
            return a.css({
                "margin-top": -(a.outerHeight() / 2)
            })
        }, a.prototype.positionElements = function() {
            return this.verticalAlign(this.social_media), this.verticalAlign(this.account), this.verticalAlign(this.menu_link), this.verticalAlign(this.cart_link), this.verticalAlign(this.currency)
        }, a.prototype.resizeListeners = function() {
            var a;
            return a = this, $(window).on("resize.LayoutHeader", function() {
                return a.positionElements()
            })
        }, a
    }(), f = function() {
        function a(a) {
            this.container = a, this.markActive = p(this.markActive, this), this.slideUp = p(this.slideUp, this), this.changeTo = p(this.changeTo, this), this.slideDown = p(this.slideDown, this), this.subMenuLinks = p(this.subMenuLinks, this), this.horizontalListeners = p(this.horizontalListeners, this), this.verticalListeners = p(this.verticalListeners, this), this.container.hasClass("vertical") && (this.type = "vertical"), this.container.hasClass("horizontal") && (this.type = "horizontal"), this.sub_menu_links = this.subMenuLinks(), this.state = "closed", this.sub_menu_panel = this.container.find(".sub_menu_panel"), this.markActive(), "horizontal" === this.type ? this.horizontalListeners() : "vertical" === this.type && this.verticalListeners()
        }
        return a.prototype.verticalListeners = function() {
            var a;
            return a = this, this.sub_menu_links.on("click.LayoutMainMenu", function() {
                return $(this).hasClass("open") ? a.slideUp($(this)) : a.slideDown($(this)), !1
            })
        }, a.prototype.horizontalListeners = function() {
            var a;
            return a = this, this.sub_menu_links.on("click.LayoutMainMenu", function() {
              	// handle rollover menu in maap.js
            	//return "closed" === a.state ? a.slideDown($(this)) : $(this).hasClass("open") ? a.slideUp($(this)) : a.changeTo($(this)), !1
            })
        }, a.prototype.subMenuLinks = function() {
            var a;
            return "horizontal" === this.type ? (a = this.container.find(".level-1 > .item").has(".level-2").find("> a"), a.addClass("sub-menu-link"), a.append('<span class="glyph--expand-more"></span><span class="glyph--expand-less"></span>'), a) : "vertical" === this.type ? (a = this.container.find(".level-1 > .item, .level-2 > .item").has(".level-2, .level-3").find("> a"), a.addClass("sub-menu-link"), a.append('<span class="glyph--expand-more"></span><span class="glyph--expand-less"></span>'), a) : void 0
        }, a.prototype.slideDown = function(a) {
            var b, c, d;
            return d = this, "horizontal" === this.type ? (this.state = "open", a.addClass("open"), b = a.closest(".item").find(".list.level-2"), b.clone().appendTo(this.sub_menu_panel), c = this.sub_menu_panel.find("> .list").outerHeight(), this.sub_menu_panel.animate({
                height: c
            }, 400), this.sub_menu_panel.find(".list.level-2").delay(200).animate({
                opacity: 1
            }, 400)) : "vertical" === this.type ? (a.addClass("open"), a.closest(".list").hasClass("level-1") ? b = a.closest(".item").find(".list.level-2") : a.closest(".list").hasClass("level-2") && (b = a.closest(".item").find(".list.level-3")), b.show()) : void 0
        }, a.prototype.changeTo = function(a) {
            var b, c;
            return c = this, b = this.sub_menu_panel.find(".list.level-2"), b.animate({
                opacity: 0
            }, 200), this.sub_menu_panel.empty(), this.container.find(".list > .item > .open").removeClass("open"), this.slideDown(a)
        }, a.prototype.slideUp = function(a) {
            var b, c;
            return c = this, "horizontal" === this.type ? (a.removeClass("open"), this.state = "closed", b = this.sub_menu_panel.find(".list.level-2"), b.hide(), this.sub_menu_panel.empty(), this.sub_menu_panel.animate({
                height: 0
            }, 400)) : "vertical" === this.type ? (a.removeClass("open"), b = a.closest(".item").find(".list.level-2"), a.closest(".list").hasClass("level-1") ? b = a.closest(".item").find(".list.level-2") : a.closest(".list").hasClass("level-2") && (b = a.closest(".item").find(".list.level-3")), b.hide()) : void 0
        }, a.prototype.markActive = function() {
            var a, b;
            return a = this, b = window.location.href, this.container.find("a").filter(function() {
                return this.href === b
            }).addClass("active")
        }, a
    }(), g = function() {
        function a() {
            this.closeRight = p(this.closeRight, this), this.closeLeft = p(this.closeLeft, this), this.closeListeners = p(this.closeListeners, this), this.fadeInOverlay = p(this.fadeInOverlay, this), this.openRight = p(this.openRight, this), this.openLeft = p(this.openLeft, this), this.openListeners = p(this.openListeners, this), this.viewPortHeightListener = p(this.viewPortHeightListener, this), this.setViewPortHeight = p(this.setViewPortHeight, this), this.toggleListeners = p(this.toggleListeners, this), this.viewport = $(".layout__off-canvas__viewport"), this.left_sidebar = $(".layout__off-canvas__sidebar.left"), this.right_sidebar = $(".layout__off-canvas__sidebar.right"), this.main_content = $(".layout__off-canvas__main-content"), this.overlay = this.main_content.find("> .overlay"), this.triggers = $(".layout__off-canvas__trigger"), this.state = "closed", this.setViewPortHeight(), this.viewPortHeightListener(), this.openListeners(), this.closeListeners()
        }
        return a.prototype.toggleListeners = function() {
            var a;
            return a = this, this.sub_menu_links.on("click.LayoutMainMenu", function() {
                return "closed" === a.state ? a.open($(this)) : $(this).hasClass("open") ? a.close($(this)) : a.changeTo($(this)), !1
            })
        }, a.prototype.setViewPortHeight = function() {
            var a;
            return a = this, a.viewport.css({
                "min-height": $(window).height()
            })
        }, a.prototype.viewPortHeightListener = function() {
            var a;
            return a = this, $(window).resize(function() {
                return a.setViewPortHeight()
            })
        }, a.prototype.openListeners = function() {
            var a;
            return a = this, this.triggers.on("click", function() {
                return $(this).hasClass("open left") ? a.openLeft() : $(this).hasClass("open right") ? a.openRight() : void 0
            }), this.right_sidebar.on("open", function() {
                return a.openRight()
            })
        }, a.prototype.openLeft = function() {
            var a;
            return a = this, this.state = "left-open", a.main_content.css({
                position: "fixed",
                top: -$(window).scrollTop()
            }), this.left_sidebar.velocity({
                translateX: [0, "-100%"]
            }, {
                complete: function() {
                    return a.left_sidebar.css({
                        position: "relative",
                        height: $(window).height()
                    })
                }
            }), this.main_content.velocity({
                translateX: ["90%", 0]
            }), this.fadeInOverlay()
        }, a.prototype.openRight = function() {
            var a;
            return a = this, this.state = "right-open", a.main_content.css({
                position: "fixed",
                top: -$(window).scrollTop()
            }), this.right_sidebar.velocity({
                translateX: [0, "100%"]
            }, {
                complete: function() {
                    return a.right_sidebar.css({
                        position: "relative",
                        left: "10%"
                    })
                }
            }), this.main_content.velocity({
                translateX: ["-90%", 0]
            }), this.fadeInOverlay()
        }, a.prototype.fadeInOverlay = function() {
            return this.overlay.show(), this.overlay.velocity({
                opacity: "0.5"
            })
        }, a.prototype.closeListeners = function() {
            var a;
            return a = this, this.overlay.on("click", function() {
                return "left-open" === a.state ? a.closeLeft() : "right-open" === a.state ? a.closeRight() : void 0
            })
        }, a.prototype.closeLeft = function() {
            var a, b;
            return b = this, this.state = "closed", a = -1 * parseInt(this.main_content.css("top")), this.left_sidebar.css({
                position: "absolute"
            }), this.main_content.css({
                position: "relative",
                top: "initial"
            }), $(window).scrollTop(a), this.left_sidebar.velocity({
                translateX: ["-100%", 0]
            }), this.main_content.velocity({
                translateX: [0, "90%"]
            }), this.overlay.velocity("fadeOut")
        }, a.prototype.closeRight = function() {
            var a, b;
            return b = this, this.state = "closed", a = -1 * parseInt(this.main_content.css("top")), this.right_sidebar.css({
                position: "absolute",
                left: "auto"
            }), this.main_content.css({
                position: "relative",
                top: "initial"
            }), $(window).scrollTop(a), this.right_sidebar.velocity({
                translateX: ["100%", 0]
            }), this.main_content.velocity({
                translateX: [0, "-90%"]
            }), this.overlay.velocity("fadeOut")
        }, a
    }(), h = function() {
        function a(a, b) {
            this.container = a, this.mq = b, this.convertCurrency = p(this.convertCurrency, this), this.openOffCanvasListener = p(this.openOffCanvasListener, this), this.removeItem = p(this.removeItem, this), this.removeItemListeners = p(this.removeItemListeners, this), this.updateTotals = p(this.updateTotals, this), this.plusQuantity = p(this.plusQuantity, this), this.minusQuantity = p(this.minusQuantity, this), this.updateQuantityListeners = p(this.updateQuantityListeners, this), this.addItem = p(this.addItem, this), this.renderOther = p(this.renderOther, this), this.renderListener = p(this.renderListener, this), this.renderCart = p(this.renderCart, this), this.adjusting_qty_timer = null, this.table_content = this.container.find("form > .content"), this.render_trigger = $(".layout__cart-modal__trigger-render"), this.totals = {}, this.add_locked = !1, this.render_locked = !1, this.container.hasClass("off-canvas") && (this.view = "off canvas"), this.container.hasClass("modal") && (this.view = "modal"), this.temp_quantity = 0, this.renderCart(), "off canvas" === this.view && this.openOffCanvasListener(), this.renderListener()
        }
        return a.prototype.renderCart = function(a) {
            var b;
            return b = this, b.render_locked ? void 0 : (b.render_locked = !0, b.table_content.empty(), $.ajax({
                type: "POST",
                url: "/cart.js",
                dataType: "json"
            }).done(function(c, d) {
                var e, f, g, h, i, j, k;
                if ("success" === d) {
                    for (e = c, e.items.length ? b.container.removeClass("no-items") : b.container.addClass("no-items"), k = e.items, f = i = 0, j = k.length; j > i; f = ++i) g = k[f], g.image_url = Shopify.resizeImage(g.image, "medium"), g.price = Currency.formatMoney(g.price, theme.money_format), h = f + 1 === e.items.length ? '<div class="variant-id last-variant width--12" data-variant-id=' + g.variant_id + ">" : '<div class="variant-id width--12" data-variant-id=' + g.variant_id + ">", h += '<div class="width--12 width--large-6 block">', h += '<span class="image block width--4 spacing--3"><a href="' + g.url + '"><img src="' + g.image_url + '" alt="' + g.title + '"></a></span>', h += '<span class="title block width--8 spacing--3 font-size--4"><a href="' + g.url + '">' + g.title + "</a></span>", h += "</div>", h += '<div class="right-column width--12 width--large-6 block spacing--3y text-align--left text-align--large-right">', h += '<span class="price spacing--3 font-size--3 money">' + g.price + "</span>", h += '<span class="quantity spacing--3"><div class="input--number"><a class="minus"><span class="glyph--minus"></span></a><input type="text" value="' + g.quantity + '" min="1" pattern="[1-9]*"><a class="plus"><span class="glyph--plus"></span></a></div></span>', h += '<span class="remove spacing--3"><a href="#" class="remove glyph--cross-circle"></a></span>', h += "</div>", h += "</div>", h += '<div class="spacer spacing--3y"></div>', b.table_content.append(h);
                    return h = '<div class="totals width--12 text-align--center ">', h += '<div class="width--12 width--large-8 block">', h += "</div>", h += '<div class="block spacing--3y width--12 width--large-4 font-size--3 text--bold text-align--large-right text--uppercase">', h += '<span class="spacing--3">' + theme.translation.cart_subtotal + "</span>", h += '<span class="total spacing--3 money">' + b.totals.price + "</span>", h += "</div>", h += "</div>", h += '<div class="spacer spacing--3y show-for-small-medium"></div>', b.table_content.append(h), b.updateTotals(), a && a(), $(window).trigger("resize.PartialModal"), b.render_locked = !1, b.removeItemListeners(), b.updateQuantityListeners(), b.convertCurrency(b.container.find(".money"))
                }
                return console.log("cart - render item status - " + d)
            }).fail(function() {
                return console.log("cart rendering failed"), b.render_locked = !1
            }))
        }, a.prototype.renderListener = function() {
            var a;
            return a = this, this.container.on("renderCart", function() {
                return a.renderCart()
            })
        }, a.prototype.renderOther = function() {
            return "small" === this.mq.current_window ? $(".partial--cart.modal").trigger("renderCart") : $(".partial--cart.off-canvas").trigger("renderCart")
        }, a.prototype.addItem = function(a, b) {
            var c;
            return c = this, c.add_locked ? void 0 : (c.add_locked = !0, $.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: "json",
                data: a.serialize()
            }).done(function() {
                return b(!0), c.renderOther(), c.add_locked = !1
            }).fail(function(a) {
                return b(!1, a.responseJSON.description), c.add_locked = !1
            }))
        }, a.prototype.updateQuantityListeners = function() {
            var a;
            return a = this, this.table_content.find(".input--number input").attr("autocomplete", "off").on("keyup.LayoutCartModal paste.LayoutCartModal", function() {
                var b, c, d;
                return c = $(this).closest(".input--number"), b = c.find("input"), parseInt(b.val()) > 0 ? (c.addClass("updating"), clearTimeout(a.adjusting_qty_timer), d = $(this).closest(".variant-id").data("variant-id"), a.adjusting_qty_timer = setTimeout(function() {
                    //return a.updateCart(d, parseInt(b.val())), c.removeClass("updating"), a.updateTotals() 
                    return a.minusQuantity(d, parseInt(b.val())), c.removeClass("updating"), a.updateTotals() // Edit by Mass
                }, 500)) : 0 === parseInt(b.val()) && (d = $(this).closest(".variant-id").data("variant-id"), a.removeItem(d), 1 === $(this).closest("form").find(".variant-id").length ? a.container.addClass("no-items") : $(this).closest(".variant-id").remove()), !1
            }), this.table_content.find(".input--number .minus").on("click.LayoutCartModal", function() {
                var b, c, d;
                return c = $(this).closest(".input--number"), b = c.find("input"), parseInt(b.val()) > 1 && (c.addClass("updating"), clearTimeout(a.adjusting_qty_timer), b.val(parseInt(b.val()) - 1), d = $(this).closest(".variant-id").data("variant-id"), a.adjusting_qty_timer = setTimeout(function() {
                    return a.minusQuantity(d, parseInt(b.val())), c.removeClass("updating"), a.updateTotals()
                }, 500)), !1
            }), this.table_content.find(".input--number .plus").on("click.LayoutCartModal", function() {
                var b, c, d;
                return clearTimeout(a.adjusting_qty_timer), c = $(this).closest(".input--number"), b = c.find("input"), 0 === a.temp_quantity && (a.temp_quantity = parseInt(b.val())), c.addClass("updating"), b.val(1 + parseInt(b.val())), d = $(this).closest(".variant-id").data("variant-id"), a.adjusting_qty_timer = setTimeout(function() {
                    var e;
                    return e = parseInt(b.val()) - a.temp_quantity, a.plusQuantity(d, e, function(d) {
                        return d ? (c.removeClass("updating"), a.updateTotals(), a.temp_quantity = 0) : (b.val(a.temp_quantity), c.removeClass("updating"), a.updateTotals(), a.temp_quantity = 0)
                    })
                }, 500), !1
            })
        }, a.prototype.minusQuantity = function(a, b) {
            var c;
            return c = this, $.ajax({
                type: "POST",
                url: "/cart/change.js",
                dataType: "json",
                data: "quantity=" + b + "&id=" + a,
                async: !1
            }).done(function(a, b) {
                return "success" === b ? (c.updateTotals(), c.renderOther()) : console.log("cart - update cart item status - " + b)
            }).fail(function() {
                return console.log("cart - update failed")
            })
        }, a.prototype.plusQuantity = function(a, b, c) {
            var d;
            return d = this, d.add_locked ? void 0 : (d.add_locked = !0, $.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: "json",
                data: "quantity=" + b + "&id=" + a
            }).done(function() {
                return c(!0), d.renderOther(), d.add_locked = !1
            }).fail(function(a) {
                return c(!1, a.responseJSON.description), d.add_locked = !1
            }))
        }, a.prototype.updateTotals = function() {
            var a;
            return a = this, $.ajax({
                type: "POST",
                url: "/cart.js",
                dataType: "json"
            }).done(function(b, c) {
                var d, e, f, g, h, i;
                if ("success" === c) {
                    for (d = b, e = {}, e.quantity = 0, e.price = 0, i = d.items, g = 0, h = i.length; h > g; g++) f = i[g], e.quantity += f.quantity, e.price += f.price * f.quantity;
                    return a.totals.count = e.quantity, a.totals.price = Currency.formatMoney(e.price, theme.money_format), a.render_trigger.find(".count").html("(" + a.totals.count + ")"), a.render_trigger.find(".total-price").replaceWith('<span class="total-price money">' + a.totals.price + "</span>"), a.table_content.find(".total").html(a.totals.price), $(".layout__header .layout__off-canvas__trigger.right").html(a.totals.count), theme.currency_switcher_enabled && (a.convertCurrency(a.render_trigger.find(".total-price")),
                    	a.convertCurrency(a.table_content.find(".total"))
                    ), a.render_trigger.show()
                }
                return console.log("cart - update totals item status - " + c)
            }).fail(function() {
                return console.log("cart - updating totals failed")
            })
        }, a.prototype.removeItemListeners = function() {
            var a;
            return a = this, this.table_content.find("a.remove").on("click.LayoutCartModal", function() {
                var b;
                return b = $(this).closest(".variant-id").data("variant-id"), a.removeItem(b), 1 === $(this).closest("form").find(".variant-id").length ? (a.container.addClass("no-items"), $(window).trigger("resize.PartialModal")) : $(this).closest(".variant-id").remove(), a.updateTotals(), !1
            })
        }, a.prototype.removeItem = function(a) {
            return this.minusQuantity(a, 0)
        }, a.prototype.openOffCanvasListener = function() {
            return $(".layout__off-canvas__cart__open-trigger").on("click", function() {
                return $(".layout__off-canvas__sidebar.right").trigger("open"), !1
            })
        }, a.prototype.convertCurrency = function(a) {
            if (Currency.shop_currency === Currency.currentCurrency) return; // Added by Mass
            return theme.currency_switcher_enabled ? Currency.convertAll(Currency.shop_currency, Currency.currentCurrency, a, null, !0) : !1
        }, a
    }(), i = function() {
        function a(a) {
            this.resizeListeners = p(this.resizeListeners, this), this.repositionCopy = p(this.repositionCopy, this), this.getImages = p(this.getImages, this), this.elem = a, this.resize_timer = null, this.items_to_load = 12, this.access_token = a.data("access-token").length ? a.data("access-token") : void 0, this.getImages(), this.resizeListeners()
        }
        return a.prototype.getImages = function() {
            var a;
            return a = this, $.ajax({
                dataType: "jsonp",
                url: "https://api.instagram.com/v1/users/self/media/recent/?access_token=" + a.access_token + "&count=" + a.items_to_load,
                success: function(b) {
                    var c, d, e, f, g, h;
                    if (200 === b.meta.code) {
                        for (d = b.data, e = g = 0, h = a.items_to_load - 1; h >= 0 ? h >= g : g >= h; e = h >= 0 ? ++g : --g) c = "", d[e] && (d[e].caption && d[e].caption.text && (c = d[e].caption.text), f = d[e].images.low_resolution.url, f = f.replace("http:", "https:"), a.elem.find(".items").append('<a class="item" target="_blank" href="' + d[e].link + '"><div class="inner"> <div class="overlay"><div class="bg"></div><p class="copy">' + c + '</p><div class="icon"><span class="glyph--instagram" title="instagram" aria-hidden="true"></span></div></div><img src="' + f + '" /> </div></a>'));
                        return a.repositionCopy()
                    }
                    return a.elem.find(".items").append('<div class="spacing--4"><p class="error">' + b.meta.error_message + '</p><p class="colored-links">Check the <strong>Social Media > Instagram</strong> section in your <a target="_blank" href="/admin/themes">theme settings</a>.</p></div>')
                },
                error: function(a, b) {
                    return console.log(a), console.log(b)
                }
            })
        }, a.prototype.repositionCopy = function() {
            var a;
            return a = this, a.elem.find(".item").each(function() {
                var a, b, c, d;
                return c = $(this), d = $(this).find(".overlay"), a = $(this).find(".copy"), b = $(this).find(".icon"), $(this).imagesLoaded(function() {
                    return c.find(".copy").dotdotdot({
                        ellipsis: "...",
                        tolerance: 0,
                        callback: function() {
                            var c;
                            return c = (d.height() - a.outerHeight()) / 2, a.css({
                                top: c
                            }), b.css({
                                top: c + a.outerHeight()
                            })
                        }
                    })
                })
            })
        }, a.prototype.resizeListeners = function() {
            var a;
            return a = this, $(window).on("resize.PartialInstagramFeed", function() {
                return clearTimeout(a.resize_timer), a.resize_timer = setTimeout(function() {
                    return a.repositionCopy()
                }, 300)
            })
        }, a
    }(), j = function() {
        function a(a) {
            this.container = a, this.fullwidth = this.container.data("fullwidth") ? !0 : !1, this.links = this.container.find(".modal-link"), this.content = this.container.find(".modal"), this.spinner = null, this.window = this.createModalWindow(), this.spinner = this.window.find(".fw__loading_animation"), this.spinner.spin("large", "#fff"), this.window_container = this.window.find("> .container"), this.mask = this.window.find("> .modal-mask"), this.close_button = this.window.find("> .close"), this.next_button = this.window.find("> .modal-next"), this.prev_button = this.window.find("> .modal-prev"), this.slider = null, this.slides = null, this.main_content_window = $(".layout__off-canvas__main-content"), this.openListeners(), this.nav_lock = !1
        }
        return a.prototype.createModalWindow = function() {
            var a, b;
            return b = this, a = null, a = $(".partial--modal.window").length ? $(".partial--modal.window") : $('<div class="partial--modal window"> <div class="modal-mask"></div> <div class="fw__loading_animation"></div> <div class="container"></div> <a aria-hidden="true" class="close glyph--cross"></a> <a aria-hidden="true" class="modal-prev glyph--chevron-left"></a> <a aria-hidden="true" class="modal-next glyph--chevron-right"></a> </div>').appendTo("body"), this.fullwidth ? a.addClass("fullwidth") : a.removeClass("fullwidth"), a
        }, a.prototype.openListeners = function() {
            var a;
            return a = this, this.links.on("click.PartialModal", function() {
                var b;
                return b = a.links.index(this), a.open(b), !1
            })
        }, a.prototype.open = function(a) {
            var b, c;
            return c = this, this.closeListeners(), this.positionListeners(), b = $(window).scrollTop(), this.main_content_window.css({
                position: "fixed",
                top: -b
            }), this.moveContentToWindow(), this.slides.length > 1 && (this.next_button.show(), this.prev_button.show(), this.prevListeners(), this.nextListeners()), this.fullwidth && this.window_container.addClass("fullwidth"), c.window.show(), c.mask.fadeIn(), c.window_container.show(), c.renderVideo(c.slides.eq(a)), c.loadModal(this.slides.eq(a), function() {
                return setTimeout(function() {
                    return c.window_container.find('input[type="text"]').focus()
                }, 0)
            })
        }, a.prototype.moveContentToWindow = function() {
            var a, b;
            return b = this, a = this.container.find(".modal"), this.window_container.append(a), this.slides = this.window_container.find("> .modal")
        }, a.prototype.detectImageSlide = function(a) {
            var b;
            return b = this, 1 === a.children().length && a.children().first().is("img") ? (a.addClass("type--image"), a.find("img").css({
                "max-height": $(window).height()
            })) : void 0
        }, a.prototype.renderVideo = function(a) {
            var b, c, d, e, f, g;
            return g = this, f = a.find(".responsive-video").first(), d = f.data("video"), e = g.extractVideoType(d), b = g.extractVideoId(d, e), c = g.createIframe(e, b), "vimeo" === e && f.addClass("vimeo"), f.append(c)
        }, a.prototype.extractVideoType = function(a) {
            var b, c;
            return c = /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i, b = c.exec(a), b ? "youtube" : (c = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/, (b = c.exec(a)) ? "vimeo" : !1)
        }, a.prototype.extractVideoId = function(a, b) {
            var c, d;
            if ("youtube" === b) {
                if (d = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/, c = a.match(d), c && 11 === c[2].length) return c[2]
            } else if ("vimeo" === b && (d = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/, c = a.match(d))) return c[2]
        }, a.prototype.createIframe = function(a, b) {
            return "youtube" === a ? '<iframe  src="//www.youtube.com/embed/' + b + '?autoplay=1" frameborder="0" allowfullwidth></iframe>' : "vimeo" === a ? '<iframe src="//player.vimeo.com/video/' + b + '?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?" frameborder="0" webkitallowfullwidth mozallowfullwidth allowfullwidth></iframe>' : void 0
        }, a.prototype.removeVideos = function() {
            return this.slides.find(".responsive-video").each(function() {
                return $(this).data("video") ? $(this).find("iframe").remove() : void 0
            })
        }, a.prototype.loadModal = function(a, b) {
            var c;
            return c = this, c.spinner.show(), setTimeout(function() {
                return a.imagesLoaded(function() {
                    return c.spinner.hide(), a.addClass("active"), c.position(), b && b(), c.nav_lock = !1
                })
            }, 300)
        }, a.prototype.position = function() {
            var a, b, c, d, e;
            return e = this, null != this.window_container ? (a = this.content.filter(".active"), e.window_container.attr("style", ""), e.positionVideoColumns(a), e.detectImageSlide(a), c = a.outerHeight(), d = a.outerWidth(), b = c + parseInt(e.window.css("padding-top")) + parseInt(e.window.css("padding-bottom")), a.hasClass("type--image") && (b = c), $(window).height() >= b ? (e.window.addClass("fixed"), a.css({
                "margin-top": -c / 2,
                "margin-left": -d / 2
            })) : (e.window.removeClass("fixed"), a.css({
                "margin-top": 0,
                "margin-left": -d / 2
            }))) : void 0
        }, a.prototype.positionVideoColumns = function(a) {
            var b, c, d, e;
            return a.find(".responsive-video").length > 0 && (b = a.find(".fw__blocks > div").eq(0), c = a.find(".fw__blocks > div").eq(1), b.css({
                width: ""
            }), c.css({
                width: ""
            }), d = b.outerHeight(), e = c.outerHeight(), e > d) ? (b.css({
                width: "100%"
            }), c.css({
                width: "100%"
            })) : void 0
        }, a.prototype.positionListeners = function() {
            var a;
            return a = this, $(window).on("resize.PartialModal", function() {
                return a.position()
            })
        }, a.prototype.nextListeners = function() {
            var a;
            return a = this, $(document).on("keydown.PartialModal", function(b) {
                return 39 === b.keyCode ? a.next() : void 0
            }), this.next_button.on("click.PartialModal", function() {
                return a.next()
            })
        }, a.prototype.next = function() {
            var a, b;
            return this.nav_lock ? void 0 : (this.nav_lock = !0, b = this.slides.filter(".active").index(), this.slides.removeClass("active"), this.removeVideos(), a = this.slides.eq(b + 1 === this.slides.length ? 0 : b + 1), this.renderVideo(a), this.loadModal(a))
        }, a.prototype.prevListeners = function() {
            var a;
            return a = this, $(document).on("keydown.PartialModal", function(b) {
                return 37 === b.keyCode ? a.prev() : void 0
            }), this.prev_button.on("click.PartialModal", function() {
                return a.prev()
            })
        }, a.prototype.prev = function() {
            var a, b;
            return this.nav_lock ? void 0 : (this.nav_lock = !0, b = this.slides.filter(".active").index(), this.slides.removeClass("active"), this.removeVideos(), a = this.slides.eq(0 === b ? this.slides.length - 1 : b - 1), this.renderVideo(a), this.loadModal(a))
        }, a.prototype.closeListeners = function() {
            var a;
            return a = this, $(document).on("keydown.PartialModal", function(b) {
                return 27 === b.keyCode ? a.close() : void 0
            }), this.mask.on("click.PartialModal", function() {
                return a.close()
            }), this.window_container.on("click.PartialModal", function() {
                return a.close()
            }), this.content.on("click.PartialModal", function(a) {
                return a.stopPropagation()
            }), this.close_button.on("click.PartialModal", function() {
                return a.close()
            })
        }, a.prototype.close = function() {
            var a, b;
            return b = this, a = -1 * parseInt(this.main_content_window.css("top")), this.container.trigger("modalClosed"), this.main_content_window.css({
                top: "0",
                position: "relative"
            }), $(window).scrollTop(a), this.putBackContent(), this.next_button.hide(), this.prev_button.hide(), this.window.hide(), this.mask.fadeOut(function() {
                return b.window_container.empty()
            }), this.removeListeners()
        }, a.prototype.putBackContent = function() {
            return this.removeVideos(), this.slides.removeClass("active").appendTo(this.container)
        }, a.prototype.removeListeners = function() {
            return $(document).off("keydown.PartialModal"), $(window).off("resize.PartialModal"), this.next_button.off("click.PartialModal"), this.prev_button.off("click.PartialModal"), this.close_button.off("click.PartialModal"), this.mask.off("click.PartialModal"), this.window_container.off("click.PartialModal")
        }, a
    }(), k = function() {
        function a(a, b, c, d) {
            this.container = a, this.cart_modal = b, this.cart_off_canvas = c, this.fw_media_queries = d, this.initiateVariants = p(this.initiateVariants, this), this.variantSelected = p(this.variantSelected, this), this.updateVariantImage = p(this.updateVariantImage, this), this.addProductComplete = p(this.addProductComplete, this), this.renderCart = p(this.renderCart, this), this.addToCartListener = p(this.addToCartListener, this), this.quantityListeners = p(this.quantityListeners, this), this.form = this.container.find("form.add-to-cart"), this.add_button = this.container.find("button.add"), this.compare_price = this.container.find(".compare-price"), this.actual_price = this.container.find(".actual-price"), this.product_unavailable = this.container.find(".product-unavailable"), this.quantity = this.container.find(".quantity"), this.handle = this.container.data("handle"), this.id = this.container.data("id"), this.view = this.container.data("view"), this.initiateVariants(), this.quantityListeners(), theme.cart_ajax_enabled && this.addToCartListener()
        }
        return a.prototype.quantityListeners = function() {
            var a;
            return a = this, a.quantity.find(".plus").on("click.PartialProduct", function() {
                var b;
                return b = a.quantity.find("input"), b.val(1 + parseInt(b.val()))
            }), a.quantity.find(".minus").on("click.PartialProduct", function() {
                var b;
                return b = a.quantity.find("input"), parseInt(b.val()) > 1 ? b.val(parseInt(b.val()) - 1) : void 0
            })
        }, a.prototype.addToCartListener = function() {
            var a;
            return a = this, this.form.length > 0 ? this.form.submit(function() {
                return a.form.find("p.error").remove(), a.add_button.addClass("loading"), a.cart_modal.addItem($(this), function(b, c) {
                    return b ? a.renderCart() : (a.form.append('<p class="error">' + c + "</p>"), a.add_button.removeClass("loading"))
                }), !1
            }) : void 0
        }, a.prototype.renderCart = function() {
            var a;
            return a = this, "small" === a.fw_media_queries.current_window ? a.cart_off_canvas.renderCart(function() {
                return a.addProductComplete()
            }) : a.cart_modal.renderCart(function() {
                return a.addProductComplete()
            })
        }, a.prototype.addProductComplete = function() {
            var a;
            return a = this, a.add_button.removeClass("loading"), "small" === a.fw_media_queries.current_window ? $(".layout__off-canvas__sidebar.right").trigger("open") : $(".partial--modal.cart .modal-link").trigger("click")
        }, a.prototype.updateVariantImage = function(a) {
            var b, c, d, e, f, g, h, i, j;
            j = this, f = j.container.closest(".product").find(".photos .photo"), e = j.container.closest(".product").find(".modal"), d = j.container.closest(".product").find(".mobile-photos .photo"), i = e.eq(a), h = f.eq(a), g = h.find("img"), c = f.first(), b = c.find("img"), 0 !== a && (g.length < 1 || (g.appendTo(c), b.appendTo(h), h = d.eq(a), g = h.find("img"), c = d.first(), b = c.find("img"), g.appendTo(c), b.appendTo(h), e.first().insertAfter(i), i.insertBefore(this.container.closest(".product").find(".modal").first())))
        }, a.prototype.variantSelected = function(a, b) {
            var c, d, e, f, g;
            g = this, c = $("#" + b.domIdPrefix).closest(".partial--product"), e = c.data("variants-size"), d = c.closest(".product").find(".details .title").html(), g.compare_price.html(""), a && a.available ? (g.quantity.show(), g.add_button.show(), g.product_unavailable.hide()) : (g.quantity.hide(), g.add_button.hide(), g.product_unavailable.show(), e > 1 && a && g.product_unavailable.find("form .email-body").attr("value", theme.translation.products_sold_out_email_description + ": " + d + " - " + a.title)), a && (g.actual_price.html(Shopify.formatMoney(a.price, theme.money_format)), a.compare_at_price > a.price && g.compare_price.html(Shopify.formatMoney(a.compare_at_price, theme.money_format)), theme.currency_switcher_enabled && (Currency.convertAll(Currency.shop_currency, Currency.currentCurrency, g.actual_price, null, !0), Currency.convertAll(Currency.shop_currency, Currency.currentCurrency, g.compare_price, null, !0)), "product-page" === g.view && (a.featured_image ? (f = c.closest(".product").find('img[data-image-id="' + a.featured_image.id + '"]').closest(".photo").index(), g.updateVariantImage(f)) : g.updateVariantImage(0)))
        }, a.prototype.initiateVariants = function() {
            var a, b, c, d;
            return d = this, !$("body.template--product").length && (c = "product-select-" + d.id, a = !1, -1 === $.inArray(c, theme.variant_id_list) ? theme.variant_id_list.push(c) : (a = !0, $("#" + c).first().attr("id", c + "--disabled")), b = !1, "product-page" === d.view && (b = !0), d.container.find("select").length > 0 && new Shopify.OptionSelectors(c, {
                product: theme.product_json[d.id],
                onVariantSelected: d.variantSelected,
                enableHistoryState: b
            }), a) ? $("#" + c + "--disabled").first().attr("id", c) : void 0
        }, a
    }(), l = function() {
        function a(a) {
            this.container = a, this.linkRows = p(this.linkRows, this), this.closeListeners = p(this.closeListeners, this), this.hideResults = p(this.hideResults, this), this.focusListener = p(this.focusListener, this), this.getResults = p(this.getResults, this), this.focusModalAlways = p(this.focusModalAlways, this), this.listenForKeyEntered = p(this.listenForKeyEntered, this), this.loadSpinners = p(this.loadSpinners, this), this.toggle_link = this.container.find("a.toggle"), this.form = this.container.find("form"), this.text_box = this.form.find('input[name="q"]'), this.loading = this.container.find("> .feedback .loading"), this.no_results = this.container.find("> .feedback .no-results"), this.results = this.container.find("> .results"), this.view = this.container.data("view"), this.max_results = 6, this.ajax_request = null, this.search_term = null, this.search_url = null, this.close_results_timer = null, this.typing_timer = null, this.focusModalAlways(), this.listenForKeyEntered(), this.loadSpinners()
        }
        return a.prototype.loadSpinners = function() {
            var a;
            return a = this.loading.find("> .animation"), a.spin(a.hasClass("tiny") ? "tiny" : "small")
        }, a.prototype.listenForKeyEntered = function() {
            var a;
            return a = this, this.text_box.attr("autocomplete", "off").on("keyup paste", function() {
                var b;
                return clearTimeout(a.typing_timer), b = $(this).val(), a.results.hide(), a.loading.show(), a.no_results.hide(), a.typing_timer = setTimeout(function() {
                    return a.search_url = "/search?type=product&q=" + b, b.length > 1 ? a.getResults(b) : (a.results.empty(), a.hideResults(), a.loading.hide())
                }, 300)
            })
        }, a.prototype.focusModalAlways = function() {
            var a;
            return a = this, "grid" === this.view ? this.container.on("click", function() {
                return a.text_box.focus()
            }) : void 0
        }, a.prototype.getResults = function() {
            var a;
            a = this, this.ajax_request && this.ajax_request.abort(), this.results.empty(), this.ajax_request = $.getJSON(this.search_url + "&view=json", function(b) {
                0 === b.results_count ? a.close_results_timer = setTimeout(function() {
                    return a.hideResults(), a.no_results.show(), a.loading.hide()
                }, 300) : (clearTimeout(a.close_results_timer), a.loading.hide(), a.no_results.hide(), a.results.show(), a.results.stop(!0, !0).fadeIn(0), $.each(b.results, function(b, c) {
                    var d;
                    b >= a.max_results || ("grid" === a.view ? (d = '<div class="partial--product item column width--medium-4 width--large-3" data-link="' + c.url + '">', d += '<a href="' + c.url + '">', d += '<div class="image-wrapper"><img src="' + c.image_medium + '" /></div>', d += '<div class="caption"><p class="title">' + c.title + "</p></div>", d += "</a></div>", d = $(d)) : "list" === a.view && (d = $('<a class="item" href="' + c.url + '"><span class="image-wrapper"><img src="' + c.image_thumb + '" /></span><span class="title">' + c.title + "</span></a>")), a.results.append(d))
                }), $.event.trigger("ie8ClearingFix"), b.results_count > a.max_results && a.results.append('<div class="row view-more"><a href="' + a.search_url + '">' + theme.translation.general_search_see_all_results + ' ("' + b.results_count + '")</a></div>'), a.closeListeners())
            }).fail(function() {
                return console.log("error retrieving search.json results")
            })
        }, a.prototype.focusListener = function() {
            var a;
            return a = this, this.text_box.on("focus", function() {
                return a.results.show()
            })
        }, a.prototype.hideResults = function() {
            return this.results.fadeOut(0), this.focusListener()
        }, a.prototype.closeListeners = function() {
            var a;
            return a = this, "grid" !== this.view ? (this.linkRows(), $(document).on("click", function(b) {
                return $(b.target).closest(".partial--searchbar").length ? void 0 : a.hideResults()
            }), $(document).keydown(function(b) {
                return 27 === b.keyCode ? a.text_box.trigger("blur") : void 0
            })) : void 0
        }, a.prototype.linkRows = function() {
            var a;
            return a = this, this.results.find("td").on("click", function() {
                var a;
                return a = $(this).parent().attr("data-link"), a.length ? window.location = a : void 0
            })
        }, a
    }(), m = function() {
        function a(a) {
            this.container = a, this.eventListeners = p(this.eventListeners, this), this.alignPlayButton = p(this.alignPlayButton, this), this.getActiveIndex = p(this.getActiveIndex, this), this.autoplay = p(this.autoplay, this), this.createSlider = p(this.createSlider, this), this.autoplay_enabled = this.container.data("autoplay") ? !0 : !1, this.navigation = this.container.data("navigation") ? !0 : !1, this.autoplay_frequency = 3e3, this.createSlider(), this.owl = $(".owl-carousel").data("owlCarousel")
        }
        return a.prototype.createSlider = function() {
            var a, b;
            return b = this, a = this.container.owlCarousel({
                singleItem: !0,
                navigation: b.navigation,
                navigationText: !1,
                pagination: b.container.data("pagination") ? !0 : !1,
                paginationNumbers: !1,
                scrollPerPageNav: !0,
                slideSpeed: 800,
                autoHeight: !1,
                autoPlay: b.autoplay(),
                afterInit: function() {
                    return b.eventListeners()
                },
                afterAction: function() {
                    return b.alignPlayButton()
                }
            }), b.navigation ? (a.find(".owl-prev").addClass("glyph--v-left"), a.find(".owl-next").addClass("glyph--v-right")) : void 0
        }, a.prototype.autoplay = function() {
            return this.autoplay_enabled ? this.autoplay_frequency : !1
        }, a.prototype.getActiveIndex = function() {
            return this.container.find(".owl-pagination .owl-page.active").index()
        }, a.prototype.alignPlayButton = function() {
            var a, b;
            return b = this.container.find(".owl-item").eq(this.getActiveIndex()), a = b.find(".play-button"), 0 !== a.length ? (a.css("visibility", "hidden"), PAGE.hasClass("transparent-menu") && "absolute" === $(".main-header").css("position") ? b.find("img").first().imagesLoaded(function() {
                var c, d, e;
                return d = b.outerHeight(), c = a.outerHeight(), e = (d - c) / 2, a.css({
                    "margin-top": 0,
                    top: e
                })
            }) : a.css({
                "margin-top": "-40px",
                top: "50%"
            }), a.css("visibility", "visible")) : void 0
        }, a.prototype.eventListeners = function() {
            var a;
            return a = this, this.container.find(".play-button").on("click", function() {
                var b;
                return b = new VideoModal($(this).closest(".video")), b.open(), a.owl.stop(), !1
            }), this.container.find(".owl-pagination .owl-page").on("click", function() {
                return a.owl.stop()
            })
        }, a
    }(), n = function() {
        function a(a) {
            this.width = parseInt(a.attr("data-width")), this.height = parseInt(a.attr("data-height")), this.row = 0, this.column = 0, this.index = ""
        }
        return a
    }(), o = function() {
        function a(a, b) {
            this.mq = b, this.touchListeners = p(this.touchListeners, this), this.resizeListeners = p(this.resizeListeners, this), this.repositionCopy = p(this.repositionCopy, this), this.resizeContainer = p(this.resizeContainer, this), this.positionTiles = p(this.positionTiles, this), this.determineTotalRows = p(this.determineTotalRows, this), this.recordTile = p(this.recordTile, this), this.incrementIndex = p(this.incrementIndex, this), this.collision = p(this.collision, this), this.sortTiles = p(this.sortTiles, this), this.createTileMatrix = p(this.createTileMatrix, this), this.row_index = 0, this.total_rows = 0, this.column_index = 0, this.matrix = [], this.container = a.children(".container"), this.tiles = this.container.find(".tile"), this.collection = [], this.resize_timer = null, this.ellipsis_initiated = !1, this.spacing = home__tiles_spacing, this.createTileMatrix(), this.sortTiles(), this.positionTiles(), this.resizeContainer(), this.repositionCopy(), this.resizeListeners(), this.touchListeners()
        }
        return a.prototype.createTileMatrix = function() {
            var a, b, c, d, e;
            for (e = this, d = [], a = c = 0; 80 > c; a = ++c) e.matrix[a] = [], d.push(function() {
                var c, d;
                for (d = [], b = c = 0; 4 > c; b = ++c) d.push(e.matrix[a][b] = 0);
                return d
            }());
            return d
        }, a.prototype.sortTiles = function() {
            var a;
            return a = this, a.tiles.each(function(b) {
                var c;
                for (c = new n($(this)), a.collection.push(c); a.collision(c);) a.incrementIndex();
                return a.recordTile(c, b)
            })
        }, a.prototype.collision = function(a) {
            var b, c, d;
            for (b = c = 0, d = a.width; d >= 0 ? d > c : c > d; b = d >= 0 ? ++c : --c) {
                if (this.column_index + b + 1 > 4) return !0;
                if (this.matrix[this.row_index][this.column_index + b]) return !0
            }
            return !1
        }, a.prototype.incrementIndex = function() {
            return 3 === this.column_index ? (this.column_index = 0, this.row_index++) : this.column_index++
        }, a.prototype.recordTile = function(a, b) {
            var c, d, e, f, g, h, i, j;
            for (j = this, a.row = j.row_index + 1, a.column = j.column_index + 1, a.index = b, i = [], c = e = 0, g = a.width; g >= 0 ? g > e : e > g; c = g >= 0 ? ++e : --e) {
                for (d = f = 0, h = a.height; h >= 0 ? h > f : f > h; d = h >= 0 ? ++f : --f) j.matrix[j.row_index + d][j.column_index] = 1;
                this.determineTotalRows(j.row_index, a.height), i.push(j.incrementIndex())
            }
            return i
        }, a.prototype.determineTotalRows = function(a, b) {
            var c;
            return c = a + b, c > this.total_rows ? this.total_rows = c : void 0
        }, a.prototype.positionTiles = function() {
            var a, b, c, d, e, f, g, h;
            for (h = this, h.container.addClass("total-rows-" + h.total_rows), g = h.collection, a = e = 0, f = g.length; f > e; a = ++e) c = g[a], b = 25 * (c.column - 1), d = (c.row - 1) / h.total_rows * 100, h.tiles.eq(c.index).css({
                left: b + "%",
                top: d + "%"
            });
            return h.container.css({
                visibility: "visible"
            }), $(".layout__footer").css({
                visibility: "visible"
            })
        }, a.prototype.resizeContainer = function() {
            var a, b, c;
            return c = this, matchMedia("only screen and (min-width: 768px)").matches || $("html").hasClass("lt-ie9") ? (b = ($(window).width() - c.spacing) / 4, a = b * c.total_rows) : a = "auto", c.container.css({
                height: a
            })
        }, a.prototype.repositionCopy = function() {
            var a;
            return a = this, a.tiles.each(function() {
                var a, b, c, d;
                return d = $(this).find(".copy-wrapper"), b = $(this).find(".copy"), a = $(this).find(".call-to-action"), c = $(this).find("img.show-for-small"), b.length ? $(this).imagesLoaded(function() {
                    return b.dotdotdot({
                        ellipsis: "...",
                        tolerance: 0,
                        callback: function() {
                            var c;
                            return c = (d.height() - b.outerHeight()) / 2, b.css({
                                top: c,
                                visibility: "visible"
                            }), a.length ? a.css({
                                top: c + b.outerHeight(),
                                visibility: "visible"
                            }) : void 0
                        }
                    })
                }) : void 0
            })
        }, a.prototype.resizeListeners = function() {
            var a;
            return a = this, $(window).on("resize.PartialTiles", function() {
                return clearTimeout(a.resize_timer), a.resize_timer = setTimeout(function() {
                    return a.resizeContainer(), a.repositionCopy()
                }, 300)
            })
        }, a.prototype.touchListeners = function() {
            var a;
            return a = this, a.tiles.find(".overlay").on("click", function() {
                return $(this).fadeIn()
            })
        }, a
    }(), jQuery(function(n) {
        var p, q, r, s, t, u, v, w, x, y, z, A, B, C;
        return q = n("body"), p = n(".layout__main-content"), theme.money_format = Currency.moneyFormats[theme.shop_currency].money_format, n(".layout__cart-modal__trigger-render span.total-price").addClass("money"), n(".template--product .partial--product.view--full .actual-price").addClass("money"), s = new a, t = new b, n('a[href^="http"]').not('a[href^="' + theme.shop_url + '"]').attr("target", "_blank"), u = "undefined" != typeof InstallTrigger, u && n("img").addClass("image-scale-hack"), n(".layout__main-menu").each(function() {
            return new f(n(this))
        }), new e(n(".layout__header")), new g, new d(n(".layout__footer")), n(".partial--tiles").each(function() {
            return new o(n(this), t)
        }), n(".partial--instagram-feed").each(function() {
            return new i(n(this))
        }), n(".partial--search").each(function() {
            return new l(n(this))
        }), n(".partial--modal").each(function() {
            return new j(n(this))
        }), v = new h(n(".partial--cart.modal"), t), w = new h(n(".partial--cart.off-canvas"), t), n(".partial--slider").each(function() {
            return new m(n(this))
        }), q.hasClass("template--product") ? theme.product = new k(n(".partial--product.view--full"), v, w, t) : n(".partial--product.view--list").each(function() {
            return new k(n(this), v, w, t)
        }), q.hasClass("template--index") && (A = function() {
            return n(".tiles").each(function() {
                var a;
                return a = new Tiles(n(this))
            }), n(".product-slider .product-grid").owlCarousel({
                items: 4,
                navigation: !0,
                scrollPerPage: !0,
                slideSpeed: 800,
                lazyLoad: !0,
                pagination: !1,
                navigationText: !1
            }), n(".product-slider .product-item").show()
        })(), q.hasClass("template--list-collections") && (B = function() {
            var a, b;
            return a = n(".layout__main-content .fw__blocks").data("columns"), 1 === a && (a = 2), b = function() {
                var b;
                return b = n(window).width() / a, "small" === t.current_window && (b = n(window).width()), p.find(".block").outerHeight(b), p.find(".title").each(function() {
                    return n(this).css({
                        "margin-top": -(n(this).outerHeight() / 2)
                    })
                })
            }, p.find(".fw__blocks").show(), b(), n(window).on("resize.TemplateListCollections", function() {
                return b()
            })
        })(), q.hasClass("template--collection") && (z = function() {
            var a;
            return a = function() {
                return p.find("header .text").css({
                    "margin-top": -(p.find(".text").outerHeight() / 2)
                })
            }, a(), n(window).on("resize.TemplateCollections", function() {
                return a()
            })
        })(), q.hasClass("template--product") && (C = function() {
            var a, b, d;
            return d = p.find(".product"), a = p.find(".column-a"), b = p.find(".column-b"), new c(d, a, b, t)
        })(), q.hasClass("template--article") && (y = function() {
            var a, b;
            return b = n(".share-buttons .glyph--pinterest"), a = n("article img").first().attr("src"), b.attr("href", b.attr("href") + "&media=" + a)
        })(), r = function() {
            return n(".sdd-download").length ? n(".sdd-download-button").removeClass("sdd-download-button").css("visibility", "visible") : void 0
        }, r(), n("html").addClass("after-js-loaded"), theme.currency_switcher_enabled && (n(".layout__cart-modal__trigger-render span.total-price").addClass("money"), n(".template--product .partial--product.view--full .actual-price").addClass("money")), n(document).on("ie8ClearingFix", function() {
            return n("html").hasClass("lt-ie9") ? n(".fw__blocks[data-ie8-clear-after]").each(function() {
                var a;
                return n(this).find(".ie8-clearer").remove(), a = n(this).data("ie8-clear-after"), n(this).children().each(function(b) {
                    return (b + 1) % a === 0 ? n('<div class="ie8-clearer"></div>').insertAfter(n(this)) : void 0
                })
            }) : void 0
        }), n.event.trigger("ie8ClearingFix"), x = function() {
            return n(window).outerHeight() > n(".layout__off-canvas__main-content").outerHeight() ? n(".layout__main-content").css({
                "min-height": n(window).outerHeight() - n(".layout__header").outerHeight() - n(".layout__footer").outerHeight()
            }) : void 0
        }, x(), n(window).resize(function() {
            return x()
        })
    })



}).call(this);
